import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '931401796468747';
export const MetaPixel = () => {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const w = window as any;
    if (!w.fbq) {
      const n: any = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      w.fbq = n;
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const firstScript = document.getElementsByTagName('script')[0];
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(t, firstScript);
      } else {
        ;
        (document.head || document.documentElement).appendChild(t);
      }
      w.fbq('init', PIXEL_ID);
    }
    w.fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-173">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-174" />
    </noscript>;
};